/**
 * CandidateStage2 lazy route wrappers (routes/candidate/index.tsx convention).
 *
 * RR v7 `lazy` route property cannot return element/children for a layout-with-children
 * subtree, so the page components are React.lazy-wrapped here and mounted via <Suspense>
 * in App.tsx. react-markdown (consent page) stays in its own chunk because only the lazy
 * CandidateStage2ConsentPage imports it.
 */
import { lazy } from "react";

const CandidateStage2ConsentPage = lazy(() =>
  import("@/features/candidate-stage2/CandidateStage2ConsentPage").then((m) => ({
    default: m.CandidateStage2ConsentPage,
  })),
);

const CandidateStage2UploadPage = lazy(() =>
  import("@/features/candidate-stage2/CandidateStage2UploadPage").then((m) => ({
    default: m.CandidateStage2UploadPage,
  })),
);

const CandidateStage2ConfirmationPage = lazy(() =>
  import("@/features/candidate-stage2/CandidateStage2ConfirmationPage").then(
    (m) => ({ default: m.CandidateStage2ConfirmationPage }),
  ),
);

export function CandidateStage2ConsentRoute() {
  return <CandidateStage2ConsentPage />;
}

export function CandidateStage2UploadRoute() {
  return <CandidateStage2UploadPage />;
}

export function CandidateStage2ConfirmationRoute() {
  return <CandidateStage2ConfirmationPage />;
}
